import React from "react";

import { useUtilizationInsightsContext } from "../../../Context/Room/Utilization/UtilizationContext";

import { CenteredBox } from "../../../../shared/CenteredBox/CenteredBox";
import { HandleLoadingState } from "../../../../shared/HandleLoadingState/HandleLoadingState";
import { HandleRequestState } from "../../../../shared/HandleRequestState/HandleRequestState";
import { LoadingBox } from "../../../../shared/LoadingBox/LoadingBox";
import { UtilizationDensityHeatMap } from "./UtilizationDensityHeatMap/UtilizationDensityHeatMap";
import { ChartCard } from "../../../shared/ChartCard/ChartCard";
import { tooltips } from "../../../../../lib/utils/tooltips";

export const UtilizationDensity = () => {
  const {
    loadingDensity: loading,
    errorDensity: error,
    roomsDensity: data,
  } = useUtilizationInsightsContext();

  return (
    <HandleLoadingState
      loading={loading}
      loadingPlaceholder={<LoadingBox minHeight={400} className="mt-4" />}
    >
      <ChartCard
        title="Meeting Density by Time/Day"
        className="mt-4 UtilizationDensity"
        direction="right"
        message={tooltips.insights.rooms.densityByTimeDay}
      >
        <HandleRequestState
          state={!!error}
          placeholder={<CenteredBox>{error?.message}</CenteredBox>}
        >
          {!!data?.data.length ? (
            <UtilizationDensityHeatMap data={data.data} />
          ) : (
            <CenteredBox>Empty data</CenteredBox>
          )}
        </HandleRequestState>
      </ChartCard>
    </HandleLoadingState>
  );
};
